const LOGIN = {
  CARD_TITLE: "ورود به اپ گفتگوی تحت وب",
  EMAIL_PH: "ایمیل",
  PASSWORD_PH: "رمز عبور",
  LOGIN: "ورود",
  FORGET_PASS_TEXT: "رمز عبور خود را فراموش کرده اید؟",
  CLICK: "کلیک کنید",
  ONE_TIME_VERIFICATION_LOGIN: "ورود با کد یکبار مصرف!",
};

export default LOGIN;
